
export interface PaddleOptions {
  priceId: string;
  customerEmail: string;
  onSuccess: (data: any) => void;
  onClose: () => void;
}

/**
 * Service to handle Paddle Subscriptions using the Paddle v2 SDK.
 * Paddle uses price IDs defined in their dashboard.
 */
export const processPaddleSubscription = async (options: PaddleOptions): Promise<void> => {
  const Paddle = (window as any).Paddle;

  if (!Paddle) {
    console.error('Paddle SDK not found. Ensure the script is included in your HTML.');
    alert('Payment gateway failed to load. Please try again later.');
    options.onClose();
    return;
  }

  // Initialize Paddle with a sandbox or live token
  Paddle.Initialize({ 
    token: 'test_your_paddle_client_token', // Replace with your client side token
    environment: 'sandbox' // or 'production'
  });

  try {
    Paddle.Checkout.open({
      settings: {
        displayMode: 'overlay',
        theme: 'light',
        locale: 'en'
      },
      items: [
        {
          priceId: options.priceId,
          quantity: 1
        }
      ],
      customer: {
        email: options.customerEmail
      },
      eventCallback: (event: any) => {
        if (event.name === 'checkout.completed') {
          console.log('Paddle Checkout Completed:', event.data);
          options.onSuccess(event.data);
        } else if (event.name === 'checkout.closed') {
          options.onClose();
        }
      }
    });
  } catch (error) {
    console.error('Failed to open Paddle checkout:', error);
    alert('Could not initialize Paddle overlay.');
    options.onClose();
  }
};
